export default "__VITE_ASSET__CXD9E9qk__"